import GridItemBase from './_grid-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurableMargin from './_configurable-margin.js'
import ConfigurableCursor from './_configurable-cursor.js'
import ConfigurableFlex from './_configurable-flex.js'

export default {
  name: 'GridCell',
  values: {
    useAbsolutePosition: false,
    style: {
      display: undefined,
      $mixin: [
        {
          configSet: GridItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurablePosition,
        },
        {
          configSet: ConfigurableMargin,
        },
        {
          configSet: ConfigurableCursor,
        },
        {
          configSet: ConfigurableFlex,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
